import _defineProperty2 from "/builds/pd/pe/global/core-front-end/web/frontend/technology-elements/sites/site-institucional/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/esnext.global-this.js";
function unwrapExports(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function createCommonjsModule(e, t) {
  return t = {
    exports: {}
  }, e(t, t.exports), t.exports;
}
function toObject(e) {
  if (null === e || void 0 === e) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}
function shouldUseNative() {
  try {
    if (!Object.assign) return !1;
    var e = new String("abc");
    if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
    for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
    if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
      return t[e];
    }).join("")) return !1;
    var r = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (e) {
      r[e] = e;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
  } catch (e) {
    return !1;
  }
}
function checkPropTypes(e, t, n, r, o) {
  for (var i in e) if (has(e, i)) {
    var s;
    try {
      if ("function" != typeof e[i]) {
        var a = Error((r || "React class") + ": " + n + " type `" + i + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[i] + "`.");
        throw a.name = "Invariant Violation", a;
      }
      s = e[i](t, i, r, n, null, ReactPropTypesSecret$1);
    } catch (e) {
      s = e;
    }
    if (!s || s instanceof Error || printWarning((r || "React class") + ": type specification of " + n + " `" + i + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof s + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), s instanceof Error && !(s.message in loggedTypeFailures)) {
      loggedTypeFailures[s.message] = !0;
      var c = o ? o() : "";
      printWarning("Failed " + n + " type: " + s.message + (null != c ? c : ""));
    }
  }
}
function emptyFunctionThatReturnsNull() {
  return null;
}
function _extends$1() {
  return (_extends$1 = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function _createClass(e, t, n) {
  return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
}
function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && _setPrototypeOf(e, t);
}
function _setPrototypeOf(e, t) {
  return (_setPrototypeOf = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function _createSuper(e) {
  return function () {
    var t,
      n = _getPrototypeOf(e);
    if (_isNativeReflectConstruct()) {
      var r = _getPrototypeOf(this).constructor;
      t = Reflect.construct(n, arguments, r);
    } else t = n.apply(this, arguments);
    return _possibleConstructorReturn(this, t);
  };
}
function _possibleConstructorReturn(e, t) {
  return !t || "object" != typeof t && "function" != typeof t ? _assertThisInitialized(e) : t;
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}
function _getPrototypeOf(e) {
  return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function _defineProperty(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function _extends$2() {
  return (_extends$2 = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
function ownKeys(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function _objectSpread(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? ownKeys(Object(n), !0).forEach(function (t) {
      _defineProperty$1(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ownKeys(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function _classCallCheck$1(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function _createClass$1(e, t, n) {
  return t && _defineProperties$1(e.prototype, t), n && _defineProperties$1(e, n), e;
}
function _inherits$1(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && _setPrototypeOf$1(e, t);
}
function _setPrototypeOf$1(e, t) {
  return (_setPrototypeOf$1 = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function _createSuper$1(e) {
  return function () {
    var t,
      n = _getPrototypeOf$1(e);
    if (_isNativeReflectConstruct$1()) {
      var r = _getPrototypeOf$1(this).constructor;
      t = Reflect.construct(n, arguments, r);
    } else t = n.apply(this, arguments);
    return _possibleConstructorReturn$1(this, t);
  };
}
function _possibleConstructorReturn$1(e, t) {
  return !t || "object" != typeof t && "function" != typeof t ? _assertThisInitialized$1(e) : t;
}
function _assertThisInitialized$1(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$1() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}
function _getPrototypeOf$1(e) {
  return (_getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function _defineProperty$1(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
import React, { Fragment, PureComponent, Component, Children, cloneElement } from "react";
import ReactDOM, { createPortal } from "react-dom";
var commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
  reactIs_development = createCommonjsModule(function (e, t) {
    !function () {
      function e(e) {
        return "string" == typeof e || "function" == typeof e || e === w || e === P || e === g || e === b || e === R || e === C || "object" == typeof e && null !== e && (e.$$typeof === k || e.$$typeof === E || e.$$typeof === T || e.$$typeof === S || e.$$typeof === O || e.$$typeof === $ || e.$$typeof === j || e.$$typeof === x || e.$$typeof === M);
      }
      function n(e) {
        if ("object" == typeof e && null !== e) {
          var t = e.$$typeof;
          switch (t) {
            case v:
              var n = e.type;
              switch (n) {
                case I:
                case P:
                case w:
                case g:
                case b:
                case R:
                  return n;
                default:
                  var r = n && n.$$typeof;
                  switch (r) {
                    case S:
                    case O:
                    case k:
                    case E:
                    case T:
                      return r;
                    default:
                      return t;
                  }
              }
            case _:
              return t;
          }
        }
      }
      function r(e) {
        return K || (K = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), o(e) || n(e) === I;
      }
      function o(e) {
        return n(e) === P;
      }
      function i(e) {
        return n(e) === S;
      }
      function s(e) {
        return n(e) === T;
      }
      function a(e) {
        return "object" == typeof e && null !== e && e.$$typeof === v;
      }
      function c(e) {
        return n(e) === O;
      }
      function u(e) {
        return n(e) === w;
      }
      function l(e) {
        return n(e) === k;
      }
      function p(e) {
        return n(e) === E;
      }
      function f(e) {
        return n(e) === _;
      }
      function d(e) {
        return n(e) === g;
      }
      function h(e) {
        return n(e) === b;
      }
      function m(e) {
        return n(e) === R;
      }
      var y = "function" == typeof Symbol && Symbol.for,
        v = y ? Symbol.for("react.element") : 60103,
        _ = y ? Symbol.for("react.portal") : 60106,
        w = y ? Symbol.for("react.fragment") : 60107,
        b = y ? Symbol.for("react.strict_mode") : 60108,
        g = y ? Symbol.for("react.profiler") : 60114,
        T = y ? Symbol.for("react.provider") : 60109,
        S = y ? Symbol.for("react.context") : 60110,
        I = y ? Symbol.for("react.async_mode") : 60111,
        P = y ? Symbol.for("react.concurrent_mode") : 60111,
        O = y ? Symbol.for("react.forward_ref") : 60112,
        R = y ? Symbol.for("react.suspense") : 60113,
        C = y ? Symbol.for("react.suspense_list") : 60120,
        E = y ? Symbol.for("react.memo") : 60115,
        k = y ? Symbol.for("react.lazy") : 60116,
        M = y ? Symbol.for("react.block") : 60121,
        $ = y ? Symbol.for("react.fundamental") : 60117,
        j = y ? Symbol.for("react.responder") : 60118,
        x = y ? Symbol.for("react.scope") : 60119,
        A = I,
        z = P,
        L = S,
        N = T,
        D = v,
        W = O,
        F = w,
        U = k,
        q = E,
        B = _,
        H = g,
        V = b,
        G = R,
        K = !1;
      t.AsyncMode = A, t.ConcurrentMode = z, t.ContextConsumer = L, t.ContextProvider = N, t.Element = D, t.ForwardRef = W, t.Fragment = F, t.Lazy = U, t.Memo = q, t.Portal = B, t.Profiler = H, t.StrictMode = V, t.Suspense = G, t.isAsyncMode = r, t.isConcurrentMode = o, t.isContextConsumer = i, t.isContextProvider = s, t.isElement = a, t.isForwardRef = c, t.isFragment = u, t.isLazy = l, t.isMemo = p, t.isPortal = f, t.isProfiler = d, t.isStrictMode = h, t.isSuspense = m, t.isValidElementType = e, t.typeOf = n;
    }();
  }),
  reactIs_development_1 = reactIs_development.AsyncMode,
  reactIs_development_2 = reactIs_development.ConcurrentMode,
  reactIs_development_3 = reactIs_development.ContextConsumer,
  reactIs_development_4 = reactIs_development.ContextProvider,
  reactIs_development_5 = reactIs_development.Element,
  reactIs_development_6 = reactIs_development.ForwardRef,
  reactIs_development_7 = reactIs_development.Fragment,
  reactIs_development_8 = reactIs_development.Lazy,
  reactIs_development_9 = reactIs_development.Memo,
  reactIs_development_10 = reactIs_development.Portal,
  reactIs_development_11 = reactIs_development.Profiler,
  reactIs_development_12 = reactIs_development.StrictMode,
  reactIs_development_13 = reactIs_development.Suspense,
  reactIs_development_14 = reactIs_development.isAsyncMode,
  reactIs_development_15 = reactIs_development.isConcurrentMode,
  reactIs_development_16 = reactIs_development.isContextConsumer,
  reactIs_development_17 = reactIs_development.isContextProvider,
  reactIs_development_18 = reactIs_development.isElement,
  reactIs_development_19 = reactIs_development.isForwardRef,
  reactIs_development_20 = reactIs_development.isFragment,
  reactIs_development_21 = reactIs_development.isLazy,
  reactIs_development_22 = reactIs_development.isMemo,
  reactIs_development_23 = reactIs_development.isPortal,
  reactIs_development_24 = reactIs_development.isProfiler,
  reactIs_development_25 = reactIs_development.isStrictMode,
  reactIs_development_26 = reactIs_development.isSuspense,
  reactIs_development_27 = reactIs_development.isValidElementType,
  reactIs_development_28 = reactIs_development.typeOf,
  reactIs = createCommonjsModule(function (e) {
    e.exports = reactIs_development;
  }),
  getOwnPropertySymbols = Object.getOwnPropertySymbols,
  hasOwnProperty = Object.prototype.hasOwnProperty,
  propIsEnumerable = Object.prototype.propertyIsEnumerable,
  objectAssign = shouldUseNative() ? Object.assign : function (e, t) {
    for (var n, r, o = toObject(e), i = 1; i < arguments.length; i++) {
      n = Object(arguments[i]);
      for (var s in n) hasOwnProperty.call(n, s) && (o[s] = n[s]);
      if (getOwnPropertySymbols) {
        r = getOwnPropertySymbols(n);
        for (var a = 0; a < r.length; a++) propIsEnumerable.call(n, r[a]) && (o[r[a]] = n[r[a]]);
      }
    }
    return o;
  },
  ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
  ReactPropTypesSecret_1 = ReactPropTypesSecret,
  printWarning = function printWarning() {},
  ReactPropTypesSecret$1 = ReactPropTypesSecret_1,
  loggedTypeFailures = {},
  has = Function.call.bind(Object.prototype.hasOwnProperty);
printWarning = function printWarning(e) {
  var t = "Warning: " + e;
  "undefined" != typeof console && console.error(t);
  try {
    throw new Error(t);
  } catch (e) {}
}, checkPropTypes.resetWarningCache = function () {
  loggedTypeFailures = {};
};
var checkPropTypes_1 = checkPropTypes,
  has$1 = Function.call.bind(Object.prototype.hasOwnProperty),
  printWarning$1 = function printWarning$1() {};
printWarning$1 = function printWarning$1(e) {
  var t = "Warning: " + e;
  "undefined" != typeof console && console.error(t);
  try {
    throw new Error(t);
  } catch (e) {}
};
var factoryWithTypeCheckers = function factoryWithTypeCheckers(e, t) {
    function n(e) {
      var t = e && (b && e[b] || e[g]);
      if ("function" == typeof t) return t;
    }
    function r(e, t) {
      return e === t ? 0 !== e || 1 / e == 1 / t : e !== e && t !== t;
    }
    function o(e) {
      this.message = e, this.stack = "";
    }
    function i(e) {
      function n(n, s, a, c, u, l, p) {
        if (c = c || T, l = l || a, p !== ReactPropTypesSecret_1) {
          if (t) {
            var f = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw f.name = "Invariant Violation", f;
          }
          if ("undefined" != typeof console) {
            var d = c + ":" + a;
            !r[d] && i < 3 && (printWarning$1("You are manually calling a React.PropTypes validation function for the `" + l + "` prop on `" + c + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), r[d] = !0, i++);
          }
        }
        return null == s[a] ? n ? new o(null === s[a] ? "The " + u + " `" + l + "` is marked as required in `" + c + "`, but its value is `null`." : "The " + u + " `" + l + "` is marked as required in `" + c + "`, but its value is `undefined`.") : null : e(s, a, c, u, l);
      }
      var r = {},
        i = 0,
        s = n.bind(null, !1);
      return s.isRequired = n.bind(null, !0), s;
    }
    function s(e) {
      function t(t, n, r, i, s, a) {
        var c = t[n];
        return y(c) !== e ? new o("Invalid " + i + " `" + s + "` of type `" + v(c) + "` supplied to `" + r + "`, expected `" + e + "`.") : null;
      }
      return i(t);
    }
    function a(e) {
      function t(t, n, r, i, s) {
        if ("function" != typeof e) return new o("Property `" + s + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
        var a = t[n];
        if (!Array.isArray(a)) return new o("Invalid " + i + " `" + s + "` of type `" + y(a) + "` supplied to `" + r + "`, expected an array.");
        for (var c = 0; c < a.length; c++) {
          var u = e(a, c, r, i, s + "[" + c + "]", ReactPropTypesSecret_1);
          if (u instanceof Error) return u;
        }
        return null;
      }
      return i(t);
    }
    function c(e) {
      function t(t, n, r, i, s) {
        if (!(t[n] instanceof e)) {
          var a = e.name || T;
          return new o("Invalid " + i + " `" + s + "` of type `" + w(t[n]) + "` supplied to `" + r + "`, expected instance of `" + a + "`.");
        }
        return null;
      }
      return i(t);
    }
    function u(e) {
      function t(t, n, i, s, a) {
        for (var c = t[n], u = 0; u < e.length; u++) if (r(c, e[u])) return null;
        var l = JSON.stringify(e, function (e, t) {
          return "symbol" === v(t) ? String(t) : t;
        });
        return new o("Invalid " + s + " `" + a + "` of value `" + String(c) + "` supplied to `" + i + "`, expected one of " + l + ".");
      }
      return Array.isArray(e) ? i(t) : (printWarning$1(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), emptyFunctionThatReturnsNull);
    }
    function l(e) {
      function t(t, n, r, i, s) {
        if ("function" != typeof e) return new o("Property `" + s + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
        var a = t[n],
          c = y(a);
        if ("object" !== c) return new o("Invalid " + i + " `" + s + "` of type `" + c + "` supplied to `" + r + "`, expected an object.");
        for (var u in a) if (has$1(a, u)) {
          var l = e(a, u, r, i, s + "." + u, ReactPropTypesSecret_1);
          if (l instanceof Error) return l;
        }
        return null;
      }
      return i(t);
    }
    function p(e) {
      function t(t, n, r, i, s) {
        for (var a = 0; a < e.length; a++) if (null == (0, e[a])(t, n, r, i, s, ReactPropTypesSecret_1)) return null;
        return new o("Invalid " + i + " `" + s + "` supplied to `" + r + "`.");
      }
      if (!Array.isArray(e)) return printWarning$1("Invalid argument supplied to oneOfType, expected an instance of array."), emptyFunctionThatReturnsNull;
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        if ("function" != typeof r) return printWarning$1("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + _(r) + " at index " + n + "."), emptyFunctionThatReturnsNull;
      }
      return i(t);
    }
    function f(e) {
      function t(t, n, r, i, s) {
        var a = t[n],
          c = y(a);
        if ("object" !== c) return new o("Invalid " + i + " `" + s + "` of type `" + c + "` supplied to `" + r + "`, expected `object`.");
        for (var u in e) {
          var l = e[u];
          if (l) {
            var p = l(a, u, r, i, s + "." + u, ReactPropTypesSecret_1);
            if (p) return p;
          }
        }
        return null;
      }
      return i(t);
    }
    function d(e) {
      function t(t, n, r, i, s) {
        var a = t[n],
          c = y(a);
        if ("object" !== c) return new o("Invalid " + i + " `" + s + "` of type `" + c + "` supplied to `" + r + "`, expected `object`.");
        var u = objectAssign({}, t[n], e);
        for (var l in u) {
          var p = e[l];
          if (!p) return new o("Invalid " + i + " `" + s + "` key `" + l + "` supplied to `" + r + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
          var f = p(a, l, r, i, s + "." + l, ReactPropTypesSecret_1);
          if (f) return f;
        }
        return null;
      }
      return i(t);
    }
    function h(t) {
      switch (typeof t) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !t;
        case "object":
          if (Array.isArray(t)) return t.every(h);
          if (null === t || e(t)) return !0;
          var r = n(t);
          if (!r) return !1;
          var o,
            i = r.call(t);
          if (r !== t.entries) {
            for (; !(o = i.next()).done;) if (!h(o.value)) return !1;
          } else for (; !(o = i.next()).done;) {
            var s = o.value;
            if (s && !h(s[1])) return !1;
          }
          return !0;
        default:
          return !1;
      }
    }
    function m(e, t) {
      return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
    }
    function y(e) {
      var t = typeof e;
      return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : m(t, e) ? "symbol" : t;
    }
    function v(e) {
      if (void 0 === e || null === e) return "" + e;
      var t = y(e);
      if ("object" === t) {
        if (e instanceof Date) return "date";
        if (e instanceof RegExp) return "regexp";
      }
      return t;
    }
    function _(e) {
      var t = v(e);
      switch (t) {
        case "array":
        case "object":
          return "an " + t;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + t;
        default:
          return t;
      }
    }
    function w(e) {
      return e.constructor && e.constructor.name ? e.constructor.name : T;
    }
    var b = "function" == typeof Symbol && Symbol.iterator,
      g = "@@iterator",
      T = "<<anonymous>>",
      S = {
        array: s("array"),
        bool: s("boolean"),
        func: s("function"),
        number: s("number"),
        object: s("object"),
        string: s("string"),
        symbol: s("symbol"),
        any: function () {
          return i(emptyFunctionThatReturnsNull);
        }(),
        arrayOf: a,
        element: function () {
          function t(t, n, r, i, s) {
            var a = t[n];
            return e(a) ? null : new o("Invalid " + i + " `" + s + "` of type `" + y(a) + "` supplied to `" + r + "`, expected a single ReactElement.");
          }
          return i(t);
        }(),
        elementType: function () {
          function e(e, t, n, r, i) {
            var s = e[t];
            return reactIs.isValidElementType(s) ? null : new o("Invalid " + r + " `" + i + "` of type `" + y(s) + "` supplied to `" + n + "`, expected a single ReactElement type.");
          }
          return i(e);
        }(),
        instanceOf: c,
        node: function () {
          function e(e, t, n, r, i) {
            return h(e[t]) ? null : new o("Invalid " + r + " `" + i + "` supplied to `" + n + "`, expected a ReactNode.");
          }
          return i(e);
        }(),
        objectOf: l,
        oneOf: u,
        oneOfType: p,
        shape: f,
        exact: d
      };
    return o.prototype = Error.prototype, S.checkPropTypes = checkPropTypes_1, S.resetWarningCache = checkPropTypes_1.resetWarningCache, S.PropTypes = S, S;
  },
  propTypes = createCommonjsModule(function (e) {
    var t = reactIs;
    e.exports = factoryWithTypeCheckers(t.isElement, !0);
  }),
  WHITE = {
    className: "basic-section bg-white"
  },
  GREY = {
    className: "bg-gray--200"
  },
  ORANGE = {
    className: "bg-orange--dark text-white"
  },
  Presets = Object.freeze({
    WHITE: WHITE,
    GREY: GREY,
    ORANGE: ORANGE
  }),
  LSection = function LSection(e) {
    var t = e.id,
      n = e.preset,
      r = e.children,
      o = Presets[n.toUpperCase()].className,
      i = r.filter(function (e) {
        return e.hasOwnProperty("$$typeof");
      }),
      s = i.map(function (e, t) {
        return React.createElement("div", {
          key: "lcolumn-cd-" + t,
          className: "col-12 col-md-" + 12 / i.length
        }, e);
      });
    return React.createElement("section", {
      id: t,
      className: o
    }, React.createElement("div", {
      className: "container"
    }, React.createElement("div", {
      className: "row align-items-center"
    }, s)));
  };
LSection.defaultProps = {};
var LColumn = function LColumn(e) {
  var t = e.children;
  return React.createElement(Fragment, null, t);
};
LColumn.defaultProps = {};
var index = {
    LSection: LSection,
    LColumn: LColumn
  },
  Icon = function Icon(e) {
    var t = e.width,
      n = e.height,
      r = e.icon,
      o = e.color,
      i = e.rotate,
      s = r.indexOf("#") > 0 ? r.split("#")[1] : r;
    return React.createElement("svg", {
      style: {
        height: n + "px",
        minHeight: n + "px",
        transform: "rotate(" + i + "deg)",
        width: t + "px",
        minWidth: t + "px"
      },
      viewBox: "0 0 " + t + " " + n,
      className: "icon icon-" + s + " fill-" + o
    }, React.createElement("use", {
      xlinkHref: "" + r
    }));
  };
Icon.defaultProps = {
  width: "",
  height: "",
  icon: "",
  color: "orange--base",
  rotate: 0
};
var classCallCheck = function classCallCheck(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  },
  createClass = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }
    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
  inherits = function inherits(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  },
  possibleConstructorReturn = function possibleConstructorReturn(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  },
  Modal = function (e) {
    function t(e) {
      classCallCheck(this, t);
      var n = possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
      return n.state = {
        isOpen: !1
      }, n.open = function (e) {
        "undefined" != typeof document && document.body.appendChild(n.container), n.setState({
          isOpen: !0
        });
      }, n.close = function () {
        n.setState({
          isOpen: !1
        });
      }, "undefined" != typeof document && (n.container = document.createElement("div")), n;
    }
    return inherits(t, e), createClass(t, [{
      key: "render",
      value: function value() {
        var e = this.state.isOpen,
          t = this.props.children;
        return e ? createPortal(t, this.container) : null;
      }
    }]), t;
  }(PureComponent);
Modal.propTypes = {
  children: propTypes.any
}, Modal.defaultProps = {
  children: React.createElement("div", null)
};
var classnames = createCommonjsModule(function (e) {
    !function () {
      function t() {
        for (var e = [], r = 0; r < arguments.length; r++) {
          var o = arguments[r];
          if (o) {
            var i = typeof o;
            if ("string" === i || "number" === i) e.push(o);else if (Array.isArray(o) && o.length) {
              var s = t.apply(null, o);
              s && e.push(s);
            } else if ("object" === i) for (var a in o) n.call(o, a) && o[a] && e.push(a);
          }
        }
        return e.join(" ");
      }
      var n = {}.hasOwnProperty;
      e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
    }();
  }),
  klass = {
    ROOT: function ROOT(e) {
      return classnames(_defineProperty2({
        "carousel-root": !0
      }, e, !!e));
    },
    CAROUSEL: function CAROUSEL(e) {
      return classnames({
        carousel: !0,
        "carousel-slider": e
      });
    },
    WRAPPER: function WRAPPER(e, t) {
      return classnames({
        "thumbs-wrapper": !e,
        "slider-wrapper": e,
        "axis-horizontal": "horizontal" === t,
        "axis-vertical": "horizontal" !== t
      });
    },
    SLIDER: function SLIDER(e, t) {
      return classnames({
        thumbs: !e,
        slider: e,
        animated: !t
      });
    },
    ITEM: function ITEM(e, t) {
      return classnames({
        thumb: !e,
        slide: e,
        selected: t
      });
    },
    ARROW_PREV: function ARROW_PREV(e) {
      return classnames({
        "control-arrow control-prev": !0,
        "control-disabled": e
      });
    },
    ARROW_NEXT: function ARROW_NEXT(e) {
      return classnames({
        "control-arrow control-next": !0,
        "control-disabled": e
      });
    },
    DOT: function DOT(e) {
      return classnames({
        dot: !0,
        selected: e
      });
    }
  },
  CSSTranslate = function CSSTranslate(e, t) {
    return "translate3d" + ("(" + ("horizontal" === t ? [e, 0, 0] : [0, e, 0]).join(",") + ")");
  },
  reactSwipe = createCommonjsModule(function (e, t) {
    !function (e, n) {
      !function (e, t, n) {
        function r(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function o(e, t) {
          var n = {};
          for (var r in e) t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
          return n;
        }
        function i(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function s(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }
        function a(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        function c(e) {
          m = e;
        }
        function u() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
            capture: !0
          };
          return m ? e : e.capture;
        }
        function l(e) {
          if ("touches" in e) {
            var t = e.touches[0];
            return {
              x: t.pageX,
              y: t.pageY
            };
          }
          return {
            x: e.screenX,
            y: e.screenY
          };
        }
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.setHasSupportToCaptureOption = c;
        var p = r(t),
          f = r(n),
          d = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          },
          h = function () {
            function e(e, t) {
              for (var n = 0; n < t.length; n++) {
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
              }
            }
            return function (t, n, r) {
              return n && e(t.prototype, n), r && e(t, r), t;
            };
          }(),
          m = !1;
        try {
          addEventListener("test", null, Object.defineProperty({}, "capture", {
            get: function get() {
              c(!0);
            }
          }));
        } catch (e) {}
        var y = function (e) {
          function t() {
            var e;
            i(this, t);
            for (var n = arguments.length, r = Array(n), o = 0; o < n; o++) r[o] = arguments[o];
            var a = s(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(r)));
            return a._handleSwipeStart = a._handleSwipeStart.bind(a), a._handleSwipeMove = a._handleSwipeMove.bind(a), a._handleSwipeEnd = a._handleSwipeEnd.bind(a), a._onMouseDown = a._onMouseDown.bind(a), a._onMouseMove = a._onMouseMove.bind(a), a._onMouseUp = a._onMouseUp.bind(a), a._setSwiperRef = a._setSwiperRef.bind(a), a;
          }
          return a(t, e), h(t, [{
            key: "componentDidMount",
            value: function value() {
              this.swiper && this.swiper.addEventListener("touchmove", this._handleSwipeMove, u({
                capture: !0,
                passive: !1
              }));
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              this.swiper && this.swiper.removeEventListener("touchmove", this._handleSwipeMove, u({
                capture: !0,
                passive: !1
              }));
            }
          }, {
            key: "_onMouseDown",
            value: function value(e) {
              this.props.allowMouseEvents && (this.mouseDown = !0, document.addEventListener("mouseup", this._onMouseUp), document.addEventListener("mousemove", this._onMouseMove), this._handleSwipeStart(e));
            }
          }, {
            key: "_onMouseMove",
            value: function value(e) {
              this.mouseDown && this._handleSwipeMove(e);
            }
          }, {
            key: "_onMouseUp",
            value: function value(e) {
              this.mouseDown = !1, document.removeEventListener("mouseup", this._onMouseUp), document.removeEventListener("mousemove", this._onMouseMove), this._handleSwipeEnd(e);
            }
          }, {
            key: "_handleSwipeStart",
            value: function value(e) {
              var t = l(e),
                n = t.x,
                r = t.y;
              this.moveStart = {
                x: n,
                y: r
              }, this.props.onSwipeStart(e);
            }
          }, {
            key: "_handleSwipeMove",
            value: function value(e) {
              if (this.moveStart) {
                var t = l(e),
                  n = t.x,
                  r = t.y,
                  o = n - this.moveStart.x,
                  i = r - this.moveStart.y;
                this.moving = !0, this.props.onSwipeMove({
                  x: o,
                  y: i
                }, e) && e.preventDefault(), this.movePosition = {
                  deltaX: o,
                  deltaY: i
                };
              }
            }
          }, {
            key: "_handleSwipeEnd",
            value: function value(e) {
              this.props.onSwipeEnd(e);
              var t = this.props.tolerance;
              this.moving && this.movePosition && (this.movePosition.deltaX < -t ? this.props.onSwipeLeft(1, e) : this.movePosition.deltaX > t && this.props.onSwipeRight(1, e), this.movePosition.deltaY < -t ? this.props.onSwipeUp(1, e) : this.movePosition.deltaY > t && this.props.onSwipeDown(1, e)), this.moveStart = null, this.moving = !1, this.movePosition = null;
            }
          }, {
            key: "_setSwiperRef",
            value: function value(e) {
              this.swiper = e, this.props.innerRef(e);
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.props,
                t = (e.tagName, e.className),
                n = e.style,
                r = e.children,
                i = (e.allowMouseEvents, e.onSwipeUp, e.onSwipeDown, e.onSwipeLeft, e.onSwipeRight, e.onSwipeStart, e.onSwipeMove, e.onSwipeEnd, e.innerRef, e.tolerance, o(e, ["tagName", "className", "style", "children", "allowMouseEvents", "onSwipeUp", "onSwipeDown", "onSwipeLeft", "onSwipeRight", "onSwipeStart", "onSwipeMove", "onSwipeEnd", "innerRef", "tolerance"]));
              return p.default.createElement(this.props.tagName, d({
                ref: this._setSwiperRef,
                onMouseDown: this._onMouseDown,
                onTouchStart: this._handleSwipeStart,
                onTouchEnd: this._handleSwipeEnd,
                className: t,
                style: n
              }, i), r);
            }
          }]), t;
        }(t.Component);
        y.displayName = "ReactSwipe", y.propTypes = {
          tagName: f.default.string,
          className: f.default.string,
          style: f.default.object,
          children: f.default.node,
          allowMouseEvents: f.default.bool,
          onSwipeUp: f.default.func,
          onSwipeDown: f.default.func,
          onSwipeLeft: f.default.func,
          onSwipeRight: f.default.func,
          onSwipeStart: f.default.func,
          onSwipeMove: f.default.func,
          onSwipeEnd: f.default.func,
          innerRef: f.default.func,
          tolerance: f.default.number.isRequired
        }, y.defaultProps = {
          tagName: "div",
          allowMouseEvents: !1,
          onSwipeUp: function onSwipeUp() {},
          onSwipeDown: function onSwipeDown() {},
          onSwipeLeft: function onSwipeLeft() {},
          onSwipeRight: function onSwipeRight() {},
          onSwipeStart: function onSwipeStart() {},
          onSwipeMove: function onSwipeMove() {},
          onSwipeEnd: function onSwipeEnd() {},
          innerRef: function innerRef() {},
          tolerance: 0
        }, e.default = y;
      }(t, React, propTypes);
    }();
  });
unwrapExports(reactSwipe);
var lib = createCommonjsModule(function (e, t) {
    !function (e, n) {
      !function (e, t) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }(t);
        e.default = n.default;
      }(t, reactSwipe);
    }();
  }),
  Swipe = unwrapExports(lib),
  outerWidth = function outerWidth(e) {
    var t = e.offsetWidth,
      n = getComputedStyle(e);
    return t += parseInt(n.marginLeft) + parseInt(n.marginRight);
  },
  getWindow = function getWindow() {
    return window;
  },
  Thumbs = function (e) {
    function t(e) {
      var r;
      return _classCallCheck(this, t), r = n.call(this, e), _defineProperty(_assertThisInitialized(r), "setItemsWrapperRef", function (e) {
        r.itemsWrapperRef = e;
      }), _defineProperty(_assertThisInitialized(r), "setItemsListRef", function (e) {
        r.itemsListRef = e;
      }), _defineProperty(_assertThisInitialized(r), "setThumbsRef", function (e, t) {
        r.thumbsRef || (r.thumbsRef = []), r.thumbsRef[t] = e;
      }), _defineProperty(_assertThisInitialized(r), "updateSizes", function () {
        if (r.props.children && r.itemsWrapperRef && 0 !== r.state.images.length) {
          var e = r.props.children.length,
            t = r.itemsWrapperRef.clientWidth,
            n = r.props.thumbWidth ? r.props.thumbWidth : outerWidth(r.thumbsRef[0]),
            o = Math.floor(t / n),
            i = e - o,
            s = o < e;
          r.setState(function (e, t) {
            return {
              itemSize: n,
              visibleItems: o,
              firstItem: s ? r.getFirstItem(t.selectedItem) : 0,
              lastPosition: i,
              showArrows: s
            };
          });
        }
      }), _defineProperty(_assertThisInitialized(r), "setMountState", function () {
        r.setState({
          hasMount: !0
        }), r.updateSizes();
      }), _defineProperty(_assertThisInitialized(r), "handleClickItem", function (e, t, n) {
        if (!n.keyCode || "Enter" === n.key) {
          var o = r.props.onSelectItem;
          "function" == typeof o && o(e, t);
        }
      }), _defineProperty(_assertThisInitialized(r), "onSwipeStart", function () {
        r.setState({
          swiping: !0
        });
      }), _defineProperty(_assertThisInitialized(r), "onSwipeEnd", function () {
        r.setState({
          swiping: !1
        });
      }), _defineProperty(_assertThisInitialized(r), "onSwipeMove", function (e) {
        var t = -r.state.firstItem * r.state.itemSize,
          n = -r.state.visibleItems * r.state.itemSize;
        0 === t && e > 0 && (e = 0), t === n && e < 0 && (e = 0);
        var o = t + 100 / (r.itemsWrapperRef.clientWidth / e) + "%";
        r.itemsListRef && ["WebkitTransform", "MozTransform", "MsTransform", "OTransform", "transform", "msTransform"].forEach(function (e) {
          r.itemsListRef.style[e] = CSSTranslate(o, r.props.axis);
        });
      }), _defineProperty(_assertThisInitialized(r), "slideRight", function (e) {
        r.moveTo(r.state.firstItem - ("number" == typeof e ? e : 1));
      }), _defineProperty(_assertThisInitialized(r), "slideLeft", function (e) {
        r.moveTo(r.state.firstItem + ("number" == typeof e ? e : 1));
      }), _defineProperty(_assertThisInitialized(r), "moveTo", function (e) {
        e = (e = e < 0 ? 0 : e) >= r.lastPosition ? r.lastPosition : e, r.setState({
          firstItem: e
        });
      }), r.state = {
        selectedItem: e.selectedItem,
        hasMount: !1,
        firstItem: 0,
        itemSize: null,
        visibleItems: 0,
        lastPosition: 0,
        showArrows: !1,
        images: r.getImages()
      }, r;
    }
    _inherits(t, e);
    var n = _createSuper(t);
    return _createClass(t, [{
      key: "componentDidMount",
      value: function value(e) {
        this.setupThumbs();
      }
    }, {
      key: "UNSAFE_componentWillReceiveProps",
      value: function value(e, t) {
        e.selectedItem !== this.state.selectedItem && this.setState({
          selectedItem: e.selectedItem,
          firstItem: this.getFirstItem(e.selectedItem)
        }), e.children !== this.props.children && this.setState({
          images: this.getImages()
        });
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e) {
        this.props.children !== e.children && this.updateSizes();
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.destroyThumbs();
      }
    }, {
      key: "setupThumbs",
      value: function value() {
        getWindow().addEventListener("resize", this.updateSizes), getWindow().addEventListener("DOMContentLoaded", this.updateSizes), this.updateSizes();
      }
    }, {
      key: "destroyThumbs",
      value: function value() {
        getWindow().removeEventListener("resize", this.updateSizes), getWindow().removeEventListener("DOMContentLoaded", this.updateSizes);
      }
    }, {
      key: "getImages",
      value: function value() {
        var e = Children.map(this.props.children, function (e, t) {
          var n = e;
          return "img" !== e.type && (n = Children.toArray(e.props.children).filter(function (e) {
            return "img" === e.type;
          })[0]), n && 0 !== n.length ? n : null;
        });
        return 0 === e.filter(function (e) {
          return e;
        }).length ? (console.warn("No images found! Can't build the thumb list without images. If you don't need thumbs, set showThumbs={false} in the Carousel. Note that it's not possible to get images rendered inside custom components. More info at https://github.com/leandrowd/react-responsive-carousel/blob/master/TROUBLESHOOTING.md"), []) : e;
      }
    }, {
      key: "getFirstItem",
      value: function value(e) {
        var t = e;
        return e >= this.state.lastPosition && (t = this.state.lastPosition), e < this.state.firstItem + this.state.visibleItems && (t = this.state.firstItem), e < this.state.firstItem && (t = e), t;
      }
    }, {
      key: "renderItems",
      value: function value() {
        var e = this;
        return this.state.images.map(function (t, n) {
          var r = klass.ITEM(!1, n === e.state.selectedItem && e.state.hasMount),
            o = {
              key: n,
              ref: function ref(t) {
                return e.setThumbsRef(t, n);
              },
              className: r,
              onClick: e.handleClickItem.bind(e, n, e.props.children[n]),
              onKeyDown: e.handleClickItem.bind(e, n, e.props.children[n]),
              "aria-label": "".concat(e.props.labels.item, " ").concat(n + 1),
              style: {
                width: e.props.thumbWidth
              }
            };
          return 0 === n && (t = React.cloneElement(t, {
            onLoad: e.setMountState
          })), React.createElement("li", _extends$1({}, o, {
            role: "button",
            tabIndex: 0
          }), t);
        });
      }
    }, {
      key: "render",
      value: function value() {
        if (!this.props.children) return null;
        var e = this.state.showArrows && this.state.firstItem > 0,
          t = this.state.showArrows && this.state.firstItem < this.state.lastPosition,
          n = {},
          r = -this.state.firstItem * this.state.itemSize + "px",
          o = CSSTranslate(r, this.props.axis),
          i = this.props.transitionTime + "ms";
        return n = {
          WebkitTransform: o,
          MozTransform: o,
          MsTransform: o,
          OTransform: o,
          transform: o,
          msTransform: o,
          WebkitTransitionDuration: i,
          MozTransitionDuration: i,
          MsTransitionDuration: i,
          OTransitionDuration: i,
          transitionDuration: i,
          msTransitionDuration: i
        }, React.createElement("div", {
          className: klass.CAROUSEL(!1)
        }, React.createElement("div", {
          className: klass.WRAPPER(!1),
          ref: this.setItemsWrapperRef
        }, React.createElement("button", {
          type: "button",
          className: klass.ARROW_PREV(!e),
          onClick: this.slideRight,
          "aria-label": this.props.labels.leftArrow
        }), React.createElement(Swipe, {
          tagName: "ul",
          className: klass.SLIDER(!1, this.state.swiping),
          onSwipeLeft: this.slideLeft,
          onSwipeRight: this.slideRight,
          onSwipeMove: this.onSwipeMove,
          onSwipeStart: this.onSwipeStart,
          onSwipeEnd: this.onSwipeEnd,
          style: n,
          innerRef: this.setItemsListRef
        }, this.renderItems()), React.createElement("button", {
          type: "button",
          className: klass.ARROW_NEXT(!t),
          onClick: this.slideLeft,
          "aria-label": this.props.labels.rightArrow
        })));
      }
    }]), t;
  }(Component);
_defineProperty(Thumbs, "displayName", "Thumbs"), _defineProperty(Thumbs, "propsTypes", {
  children: propTypes.element.isRequired,
  transitionTime: propTypes.number,
  selectedItem: propTypes.number,
  thumbWidth: propTypes.number,
  labels: propTypes.shape({
    leftArrow: propTypes.string,
    rightArrow: propTypes.string,
    item: propTypes.string
  })
}), _defineProperty(Thumbs, "defaultProps", {
  selectedItem: 0,
  thumbWidth: 80,
  transitionTime: 350,
  axis: "horizontal"
});
var unit = function unit(e, t, n) {
    if (!/(pt|px|em|rem|vw|vh|%)$/.test(e[t])) return new Error("Invalid prop `" + t + "` supplied to `" + n + "`. Validation failed. It needs to be a size unit like pt, px, em, rem, vw, %");
  },
  getDocument = function getDocument() {
    return document;
  },
  noop = function noop() {},
  defaultStatusFormatter = function defaultStatusFormatter(e, t) {
    return "".concat(e, " of ").concat(t);
  },
  Carousel = function (e) {
    function t(e) {
      var r;
      return _classCallCheck$1(this, t), r = n.call(this, e), _defineProperty$1(_assertThisInitialized$1(r), "setThumbsRef", function (e) {
        r.thumbsRef = e;
      }), _defineProperty$1(_assertThisInitialized$1(r), "setCarouselWrapperRef", function (e) {
        r.carouselWrapperRef = e;
      }), _defineProperty$1(_assertThisInitialized$1(r), "setListRef", function (e) {
        r.listRef = e;
      }), _defineProperty$1(_assertThisInitialized$1(r), "setItemsWrapperRef", function (e) {
        r.itemsWrapperRef = e;
      }), _defineProperty$1(_assertThisInitialized$1(r), "setItemsRef", function (e, t) {
        r.itemsRef || (r.itemsRef = []), r.itemsRef[t] = e;
      }), _defineProperty$1(_assertThisInitialized$1(r), "autoPlay", function () {
        !r.state.autoPlay || Children.count(r.props.children) <= 1 || (clearTimeout(r.timer), r.timer = setTimeout(function () {
          r.increment();
        }, r.props.interval));
      }), _defineProperty$1(_assertThisInitialized$1(r), "clearAutoPlay", function () {
        r.state.autoPlay && clearTimeout(r.timer);
      }), _defineProperty$1(_assertThisInitialized$1(r), "resetAutoPlay", function () {
        r.clearAutoPlay(), r.autoPlay();
      }), _defineProperty$1(_assertThisInitialized$1(r), "stopOnHover", function () {
        r.setState({
          isMouseEntered: !0
        }), r.clearAutoPlay();
      }), _defineProperty$1(_assertThisInitialized$1(r), "startOnLeave", function () {
        r.setState({
          isMouseEntered: !1
        }), r.autoPlay();
      }), _defineProperty$1(_assertThisInitialized$1(r), "isFocusWithinTheCarousel", function () {
        return !(getDocument().activeElement !== r.carouselWrapperRef && !r.carouselWrapperRef.contains(getDocument().activeElement));
      }), _defineProperty$1(_assertThisInitialized$1(r), "navigateWithKeyboard", function (e) {
        if (r.isFocusWithinTheCarousel()) {
          var t = "horizontal" === r.props.axis,
            n = {
              ArrowUp: 38,
              ArrowRight: 39,
              ArrowDown: 40,
              ArrowLeft: 37
            },
            o = t ? n.ArrowRight : n.ArrowDown,
            i = t ? n.ArrowLeft : n.ArrowUp;
          o === e.keyCode ? r.increment() : i === e.keyCode && r.decrement();
        }
      }), _defineProperty$1(_assertThisInitialized$1(r), "updateSizes", function () {
        if (r.state.initialized) {
          var e = "horizontal" === r.props.axis,
            t = r.itemsRef[0],
            n = e ? t.clientWidth : t.clientHeight;
          r.setState(function (e, t) {
            return {
              itemSize: n
            };
          }), r.thumbsRef && r.thumbsRef.updateSizes();
        }
      }), _defineProperty$1(_assertThisInitialized$1(r), "setMountState", function () {
        r.setState({
          hasMount: !0
        }), r.updateSizes();
      }), _defineProperty$1(_assertThisInitialized$1(r), "handleClickItem", function (e, t) {
        if (0 !== Children.count(r.props.children)) {
          if (r.state.cancelClick) return void r.setState({
            cancelClick: !1
          });
          r.props.onClickItem(e, t), e !== r.state.selectedItem && r.setState({
            selectedItem: e
          });
        }
      }), _defineProperty$1(_assertThisInitialized$1(r), "handleOnChange", function (e, t) {
        Children.count(r.props.children) <= 1 || r.props.onChange(e, t);
      }), _defineProperty$1(_assertThisInitialized$1(r), "handleClickThumb", function (e, t) {
        r.props.onClickThumb(e, t), r.selectItem({
          selectedItem: e
        });
      }), _defineProperty$1(_assertThisInitialized$1(r), "onSwipeStart", function (e) {
        r.setState({
          swiping: !0
        }), r.props.onSwipeStart(e), r.clearAutoPlay();
      }), _defineProperty$1(_assertThisInitialized$1(r), "onSwipeEnd", function (e) {
        r.setState({
          swiping: !1,
          cancelClick: !1
        }), r.props.onSwipeEnd(e), r.autoPlay();
      }), _defineProperty$1(_assertThisInitialized$1(r), "onSwipeMove", function (e, t) {
        r.props.onSwipeMove(t);
        var n = "horizontal" === r.props.axis,
          o = Children.count(r.props.children),
          i = r.getPosition(r.state.selectedItem),
          s = r.props.infiniteLoop ? r.getPosition(o - 1) - 100 : r.getPosition(o - 1),
          a = n ? e.x : e.y,
          c = a;
        0 === i && a > 0 && (c = 0), i === s && a < 0 && (c = 0);
        var u = i + 100 / (r.state.itemSize / c);
        r.props.infiniteLoop && (0 === r.state.selectedItem && u > -100 ? u -= 100 * o : r.state.selectedItem === o - 1 && u < 100 * -o && (u += 100 * o)), u += "%", r.setPosition(u);
        var l = Math.abs(a) > r.props.swipeScrollTolerance;
        return l && !r.state.cancelClick && r.setState({
          cancelClick: !0
        }), l;
      }), _defineProperty$1(_assertThisInitialized$1(r), "setPosition", function (e, t) {
        var n = ReactDOM.findDOMNode(r.listRef);
        ["WebkitTransform", "MozTransform", "MsTransform", "OTransform", "transform", "msTransform"].forEach(function (t) {
          n.style[t] = CSSTranslate(e, r.props.axis);
        }), t && n.offsetLeft;
      }), _defineProperty$1(_assertThisInitialized$1(r), "resetPosition", function () {
        var e = r.getPosition(r.state.selectedItem) + "%";
        r.setPosition(e);
      }), _defineProperty$1(_assertThisInitialized$1(r), "decrement", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
          t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        r.moveTo(r.state.selectedItem - ("number" == typeof e ? e : 1), t);
      }), _defineProperty$1(_assertThisInitialized$1(r), "increment", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
          t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        r.moveTo(r.state.selectedItem + ("number" == typeof e ? e : 1), t);
      }), _defineProperty$1(_assertThisInitialized$1(r), "moveTo", function (e, t) {
        var n = Children.count(r.props.children) - 1,
          o = r.props.infiniteLoop && !t && (e < 0 || e > n),
          i = e;
        e < 0 && (e = r.props.infiniteLoop ? n : 0), e > n && (e = r.props.infiniteLoop ? 0 : n), o ? r.setState({
          swiping: !0
        }, function () {
          i < 0 ? r.props.centerMode && "horizontal" === r.props.axis ? r.setPosition("-".concat((n + 2) * r.props.centerSlidePercentage - (100 - r.props.centerSlidePercentage) / 2, "%"), !0) : r.setPosition("-".concat(100 * (n + 2), "%"), !0) : i > n && r.setPosition(0, !0), r.selectItem({
            selectedItem: e,
            swiping: !1
          });
        }) : r.selectItem({
          selectedItem: e
        }), r.state.autoPlay && !1 === r.state.isMouseEntered && r.resetAutoPlay();
      }), _defineProperty$1(_assertThisInitialized$1(r), "onClickNext", function () {
        r.increment(1, !1);
      }), _defineProperty$1(_assertThisInitialized$1(r), "onClickPrev", function () {
        r.decrement(1, !1);
      }), _defineProperty$1(_assertThisInitialized$1(r), "onSwipeForward", function () {
        r.increment(1, !0);
      }), _defineProperty$1(_assertThisInitialized$1(r), "onSwipeBackwards", function () {
        r.decrement(1, !0);
      }), _defineProperty$1(_assertThisInitialized$1(r), "changeItem", function (e) {
        if (!e.key || "Enter" === e.key) {
          var t = e.target.value;
          r.selectItem({
            selectedItem: t
          });
        }
      }), _defineProperty$1(_assertThisInitialized$1(r), "selectItem", function (e, t) {
        r.setState(e, t), r.handleOnChange(e.selectedItem, Children.toArray(r.props.children)[e.selectedItem]);
      }), _defineProperty$1(_assertThisInitialized$1(r), "getInitialImage", function () {
        var e = r.props.selectedItem,
          t = r.itemsRef && r.itemsRef[e],
          n = t && t.getElementsByTagName("img");
        return n && n[e];
      }), _defineProperty$1(_assertThisInitialized$1(r), "getVariableImageHeight", function (e) {
        var t = r.itemsRef && r.itemsRef[e],
          n = t && t.getElementsByTagName("img");
        if (r.state.hasMount && n.length > 0) {
          var o = n[0];
          if (!o.complete) {
            var i = function e() {
              r.forceUpdate(), o.removeEventListener("load", e);
            };
            o.addEventListener("load", i);
          }
          var s = o.clientHeight;
          return s > 0 ? s : null;
        }
        return null;
      }), r.state = {
        initialized: !1,
        selectedItem: e.selectedItem,
        hasMount: !1,
        isMouseEntered: !1,
        autoPlay: e.autoPlay
      }, r;
    }
    _inherits$1(t, e);
    var n = _createSuper$1(t);
    return _createClass$1(t, [{
      key: "componentDidMount",
      value: function value() {
        this.props.children && this.setupCarousel();
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e, t) {
        e.children || !this.props.children || this.state.initialized || this.setupCarousel(), t.swiping && !this.state.swiping && this.resetPosition(), e.selectedItem === this.props.selectedItem && e.centerMode === this.props.centerMode || (this.updateSizes(), this.moveTo(this.props.selectedItem)), e.autoPlay !== this.props.autoPlay && (this.props.autoPlay ? this.setupAutoPlay() : this.destroyAutoPlay(), this.setState({
          autoPlay: this.props.autoPlay
        }));
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.destroyCarousel();
      }
    }, {
      key: "setupCarousel",
      value: function value() {
        this.bindEvents(), this.state.autoPlay && Children.count(this.props.children) > 1 && this.setupAutoPlay(), this.setState({
          initialized: !0
        });
        var e = this.getInitialImage();
        e ? e.addEventListener("load", this.setMountState) : this.setMountState();
      }
    }, {
      key: "destroyCarousel",
      value: function value() {
        this.state.initialized && (this.unbindEvents(), this.destroyAutoPlay());
      }
    }, {
      key: "setupAutoPlay",
      value: function value() {
        this.autoPlay();
        var e = this.carouselWrapperRef;
        this.props.stopOnHover && e && (e.addEventListener("mouseenter", this.stopOnHover), e.addEventListener("mouseleave", this.startOnLeave));
      }
    }, {
      key: "destroyAutoPlay",
      value: function value() {
        this.clearAutoPlay();
        var e = this.carouselWrapperRef;
        this.props.stopOnHover && e && (e.removeEventListener("mouseenter", this.stopOnHover), e.removeEventListener("mouseleave", this.startOnLeave));
      }
    }, {
      key: "bindEvents",
      value: function value() {
        getWindow().addEventListener("resize", this.updateSizes), getWindow().addEventListener("DOMContentLoaded", this.updateSizes), this.props.useKeyboardArrows && getDocument().addEventListener("keydown", this.navigateWithKeyboard);
      }
    }, {
      key: "unbindEvents",
      value: function value() {
        getWindow().removeEventListener("resize", this.updateSizes), getWindow().removeEventListener("DOMContentLoaded", this.updateSizes);
        var e = this.getInitialImage();
        e && e.removeEventListener("load", this.setMountState), this.props.useKeyboardArrows && getDocument().removeEventListener("keydown", this.navigateWithKeyboard);
      }
    }, {
      key: "getPosition",
      value: function value(e) {
        if (this.props.infiniteLoop && ++e, 0 === e) return 0;
        var t = Children.count(this.props.children);
        if (this.props.centerMode && "horizontal" === this.props.axis) {
          var n = -e * this.props.centerSlidePercentage,
            r = t - 1;
          return e && (e !== r || this.props.infiniteLoop) ? n += (100 - this.props.centerSlidePercentage) / 2 : e === r && (n += 100 - this.props.centerSlidePercentage), n;
        }
        return 100 * -e;
      }
    }, {
      key: "renderItems",
      value: function value(e) {
        var t = this;
        return Children.map(this.props.children, function (n, r) {
          var o = {
            ref: function ref(e) {
              return t.setItemsRef(e, r);
            },
            key: "itemKey" + r + (e ? "clone" : ""),
            className: klass.ITEM(!0, r === t.state.selectedItem),
            onClick: t.handleClickItem.bind(t, r, n)
          };
          return t.props.centerMode && "horizontal" === t.props.axis && (o.style = {
            minWidth: t.props.centerSlidePercentage + "%"
          }), React.createElement("li", o, t.props.renderItem(n, {
            isSelected: r === t.state.selectedItem
          }));
        });
      }
    }, {
      key: "renderControls",
      value: function value() {
        var e = this;
        return this.props.showIndicators ? React.createElement("ul", {
          className: "control-dots"
        }, Children.map(this.props.children, function (t, n) {
          return e.props.renderIndicator(e.changeItem, n === e.state.selectedItem, n, e.props.labels.item);
        })) : null;
      }
    }, {
      key: "renderStatus",
      value: function value() {
        return this.props.showStatus ? React.createElement("p", {
          className: "carousel-status"
        }, this.props.statusFormatter(this.state.selectedItem + 1, Children.count(this.props.children))) : null;
      }
    }, {
      key: "renderThumbs",
      value: function value() {
        return this.props.showThumbs && 0 !== Children.count(this.props.children) ? React.createElement(Thumbs, {
          ref: this.setThumbsRef,
          onSelectItem: this.handleClickThumb,
          selectedItem: this.state.selectedItem,
          transitionTime: this.props.transitionTime,
          thumbWidth: this.props.thumbWidth,
          labels: this.props.labels
        }, this.props.renderThumbs(this.props.children)) : null;
      }
    }, {
      key: "render",
      value: function value() {
        if (!this.props.children || 0 === Children.count(this.props.children)) return null;
        var e = "horizontal" === this.props.axis,
          t = this.props.showArrows && Children.count(this.props.children) > 1,
          n = t && (this.state.selectedItem > 0 || this.props.infiniteLoop),
          r = t && (this.state.selectedItem < Children.count(this.props.children) - 1 || this.props.infiniteLoop),
          o = {},
          i = this.getPosition(this.state.selectedItem),
          s = CSSTranslate(i + "%", this.props.axis),
          a = this.props.transitionTime + "ms";
        o = {
          WebkitTransform: s,
          MozTransform: s,
          MsTransform: s,
          OTransform: s,
          transform: s,
          msTransform: s
        }, this.state.swiping || (o = _objectSpread({}, o, {
          WebkitTransitionDuration: a,
          MozTransitionDuration: a,
          MsTransitionDuration: a,
          OTransitionDuration: a,
          transitionDuration: a,
          msTransitionDuration: a
        }));
        var c = this.renderItems(!0),
          u = c.shift(),
          l = c.pop(),
          p = {
            className: klass.SLIDER(!0, this.state.swiping),
            onSwipeMove: this.onSwipeMove,
            onSwipeStart: this.onSwipeStart,
            onSwipeEnd: this.onSwipeEnd,
            style: o,
            tolerance: this.props.swipeScrollTolerance
          },
          f = {};
        if (e) {
          if (p.onSwipeLeft = this.onSwipeForward, p.onSwipeRight = this.onSwipeBackwards, this.props.dynamicHeight) {
            var d = this.getVariableImageHeight(this.state.selectedItem);
            p.style.height = d || "auto", f.height = d || "auto";
          }
        } else p.onSwipeUp = "natural" === this.props.verticalSwipe ? this.onSwipeBackwards : this.onSwipeForward, p.onSwipeDown = "natural" === this.props.verticalSwipe ? this.onSwipeForward : this.onSwipeBackwards, p.style.height = this.state.itemSize, f.height = this.state.itemSize;
        return React.createElement("div", {
          className: klass.ROOT(this.props.className),
          ref: this.setCarouselWrapperRef,
          tabIndex: "0"
        }, React.createElement("div", {
          className: klass.CAROUSEL(!0),
          style: {
            width: this.props.width
          }
        }, this.props.renderArrowPrev(this.onClickPrev, n, this.props.labels.leftArrow), React.createElement("div", {
          className: klass.WRAPPER(!0, this.props.axis),
          style: f,
          ref: this.setItemsWrapperRef
        }, this.props.swipeable ? React.createElement(Swipe, _extends$2({
          tagName: "ul",
          ref: this.setListRef
        }, p, {
          allowMouseEvents: this.props.emulateTouch
        }), this.props.infiniteLoop && l, this.renderItems(), this.props.infiniteLoop && u) : React.createElement("ul", {
          className: klass.SLIDER(!0, this.state.swiping),
          ref: this.setListRef,
          style: o
        }, this.props.infiniteLoop && l, this.renderItems(), this.props.infiniteLoop && u)), this.props.renderArrowNext(this.onClickNext, r, this.props.labels.rightArrow), this.renderControls(), this.renderStatus()), this.renderThumbs());
      }
    }]), t;
  }(Component);
_defineProperty$1(Carousel, "displayName", "Carousel"), _defineProperty$1(Carousel, "propTypes", {
  className: propTypes.string,
  children: propTypes.node,
  showArrows: propTypes.bool,
  showStatus: propTypes.bool,
  showIndicators: propTypes.bool,
  infiniteLoop: propTypes.bool,
  showThumbs: propTypes.bool,
  thumbWidth: propTypes.number,
  selectedItem: propTypes.number,
  onClickItem: propTypes.func.isRequired,
  onClickThumb: propTypes.func.isRequired,
  onChange: propTypes.func.isRequired,
  axis: propTypes.oneOf(["horizontal", "vertical"]),
  verticalSwipe: propTypes.oneOf(["natural", "standard"]),
  width: unit,
  useKeyboardArrows: propTypes.bool,
  autoPlay: propTypes.bool,
  stopOnHover: propTypes.bool,
  interval: propTypes.number,
  transitionTime: propTypes.number,
  swipeScrollTolerance: propTypes.number,
  swipeable: propTypes.bool,
  dynamicHeight: propTypes.bool,
  emulateTouch: propTypes.bool,
  statusFormatter: propTypes.func.isRequired,
  centerMode: propTypes.bool,
  centerSlidePercentage: propTypes.number,
  labels: propTypes.shape({
    leftArrow: propTypes.string,
    rightArrow: propTypes.string,
    item: propTypes.string
  }),
  onSwipeStart: propTypes.func,
  onSwipeEnd: propTypes.func,
  onSwipeMove: propTypes.func,
  renderArrowPrev: propTypes.func,
  renderArrowNext: propTypes.func,
  renderIndicator: propTypes.func,
  renderItem: propTypes.func,
  renderThumbs: propTypes.func
}), _defineProperty$1(Carousel, "defaultProps", {
  showIndicators: !0,
  showArrows: !0,
  showStatus: !0,
  showThumbs: !0,
  infiniteLoop: !1,
  selectedItem: 0,
  axis: "horizontal",
  verticalSwipe: "standard",
  width: "100%",
  useKeyboardArrows: !1,
  autoPlay: !1,
  stopOnHover: !0,
  interval: 3e3,
  transitionTime: 350,
  swipeScrollTolerance: 5,
  swipeable: !0,
  dynamicHeight: !1,
  emulateTouch: !1,
  onClickItem: noop,
  onClickThumb: noop,
  onChange: noop,
  statusFormatter: defaultStatusFormatter,
  centerMode: !1,
  centerSlidePercentage: 80,
  labels: {
    leftArrow: "previous slide / item",
    rightArrow: "next slide / item",
    item: "slide item"
  },
  onSwipeStart: function onSwipeStart() {},
  onSwipeEnd: function onSwipeEnd() {},
  onSwipeMove: function onSwipeMove() {},
  renderArrowPrev: function renderArrowPrev(e, t, n) {
    return React.createElement("button", {
      type: "button",
      "aria-label": n,
      className: klass.ARROW_PREV(!t),
      onClick: e
    });
  },
  renderArrowNext: function renderArrowNext(e, t, n) {
    return React.createElement("button", {
      type: "button",
      "aria-label": n,
      className: klass.ARROW_NEXT(!t),
      onClick: e
    });
  },
  renderIndicator: function renderIndicator(e, t, n, r) {
    return React.createElement("li", {
      className: klass.DOT(t),
      onClick: e,
      onKeyDown: e,
      value: n,
      key: n,
      role: "button",
      tabIndex: 0,
      "aria-label": "".concat(r, " ").concat(n + 1)
    });
  },
  renderItem: function renderItem(e, t) {
    t.isSelected;
    return e;
  },
  renderThumbs: function renderThumbs(e) {
    return e;
  }
});
var Slider = function (e) {
  function t() {
    return classCallCheck(this, t), possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
  }
  return inherits(t, e), createClass(t, [{
    key: "render",
    value: function value() {
      var e = this.props,
        t = e.children,
        n = e.infiniteLoop,
        r = e.autoPlay,
        o = e.transitionTime,
        i = n && !0,
        s = "true" === r || !0 === r,
        a = +o;
      return React.createElement("div", {
        className: "slider-content"
      }, React.createElement(Carousel, {
        showStatus: !1,
        showThumbs: !1,
        infiniteLoop: i,
        autoPlay: s,
        transitionTime: a
      }, t.filter(function (e) {
        return e.props && e.props.className && "slide-page" === e.props.className;
      })));
    }
  }]), t;
}(PureComponent);
Slider.defaultProps = {
  infiniteLoop: "false",
  autoPlay: !1,
  children: null,
  transitionTime: 700
};
var LoadingIndicator = function LoadingIndicator(e) {
  var t = e.size,
    n = {
      small: "small",
      large: "large"
    };
  return React.createElement("svg", {
    className: "loading__icon loading__icon--" + (n[t] ? n[t] : n.default),
    width: "36",
    height: "36",
    viewBox: "0 0 36 36"
  }, React.createElement("path", {
    d: "M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831",
    fill: "none"
  }));
};
LoadingIndicator.defaultProps = {
  size: "default"
};
for (var performanceNow = createCommonjsModule(function (e) {
    (function () {
      var t, n, r, o, i, s;
      "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function () {
        return performance.now();
      } : "undefined" != typeof process && null !== process && process.hrtime ? (e.exports = function () {
        return (t() - i) / 1e6;
      }, n = process.hrtime, o = (t = function t() {
        var e;
        return 1e9 * (e = n())[0] + e[1];
      })(), s = 1e9 * process.uptime(), i = o - s) : Date.now ? (e.exports = function () {
        return Date.now() - r;
      }, r = Date.now()) : (e.exports = function () {
        return new Date().getTime() - r;
      }, r = new Date().getTime());
    }).call(commonjsGlobal);
  }), root = "undefined" == typeof window ? commonjsGlobal : window, vendors = ["moz", "webkit"], suffix = "AnimationFrame", raf = root["request" + suffix], caf = root["cancel" + suffix] || root["cancelRequest" + suffix], i = 0; !raf && i < vendors.length; i++) raf = root[vendors[i] + "Request" + suffix], caf = root[vendors[i] + "Cancel" + suffix] || root[vendors[i] + "CancelRequest" + suffix];
if (!raf || !caf) {
  var last = 0,
    id = 0,
    queue = [],
    frameDuration = 1e3 / 60;
  raf = function raf(e) {
    if (0 === queue.length) {
      var t = performanceNow(),
        n = Math.max(0, frameDuration - (t - last));
      last = n + t, setTimeout(function () {
        var e = queue.slice(0);
        queue.length = 0;
        for (var t = 0; t < e.length; t++) if (!e[t].cancelled) try {
          e[t].callback(last);
        } catch (e) {
          setTimeout(function () {
            throw e;
          }, 0);
        }
      }, Math.round(n));
    }
    return queue.push({
      handle: ++id,
      callback: e,
      cancelled: !1
    }), id;
  }, caf = function caf(e) {
    for (var t = 0; t < queue.length; t++) queue[t].handle === e && (queue[t].cancelled = !0);
  };
}
var raf_1 = function raf_1(e) {
    return raf.call(root, e);
  },
  cancel = function cancel() {
    caf.apply(root, arguments);
  },
  polyfill = function polyfill(e) {
    e || (e = root), e.requestAnimationFrame = raf, e.cancelAnimationFrame = caf;
  };
raf_1.cancel = cancel, raf_1.polyfill = polyfill;
var Tween = createCommonjsModule(function (e, t) {
    var n = function n() {
      this._tweens = {}, this._tweensAddedDuringUpdate = {};
    };
    n.prototype = {
      getAll: function getAll() {
        return Object.keys(this._tweens).map(function (e) {
          return this._tweens[e];
        }.bind(this));
      },
      removeAll: function removeAll() {
        this._tweens = {};
      },
      add: function add(e) {
        this._tweens[e.getId()] = e, this._tweensAddedDuringUpdate[e.getId()] = e;
      },
      remove: function remove(e) {
        delete this._tweens[e.getId()], delete this._tweensAddedDuringUpdate[e.getId()];
      },
      update: function update(e, t) {
        var n = Object.keys(this._tweens);
        if (0 === n.length) return !1;
        for (e = void 0 !== e ? e : r.now(); n.length > 0;) {
          this._tweensAddedDuringUpdate = {};
          for (var o = 0; o < n.length; o++) {
            var i = this._tweens[n[o]];
            i && !1 === i.update(e) && (i._isPlaying = !1, t || delete this._tweens[n[o]]);
          }
          n = Object.keys(this._tweensAddedDuringUpdate);
        }
        return !0;
      }
    };
    var r = new n();
    r.Group = n, r._nextId = 0, r.nextId = function () {
      return r._nextId++;
    }, "undefined" == typeof window && "undefined" != typeof process ? r.now = function () {
      var e = process.hrtime();
      return 1e3 * e[0] + e[1] / 1e6;
    } : "undefined" != typeof window && void 0 !== window.performance && void 0 !== window.performance.now ? r.now = window.performance.now.bind(window.performance) : void 0 !== Date.now ? r.now = Date.now : r.now = function () {
      return new Date().getTime();
    }, r.Tween = function (e, t) {
      this._object = e, this._valuesStart = {}, this._valuesEnd = {}, this._valuesStartRepeat = {}, this._duration = 1e3, this._repeat = 0, this._repeatDelayTime = void 0, this._yoyo = !1, this._isPlaying = !1, this._reversed = !1, this._delayTime = 0, this._startTime = null, this._easingFunction = r.Easing.Linear.None, this._interpolationFunction = r.Interpolation.Linear, this._chainedTweens = [], this._onStartCallback = null, this._onStartCallbackFired = !1, this._onUpdateCallback = null, this._onCompleteCallback = null, this._onStopCallback = null, this._group = t || r, this._id = r.nextId();
    }, r.Tween.prototype = {
      getId: function getId() {
        return this._id;
      },
      isPlaying: function isPlaying() {
        return this._isPlaying;
      },
      to: function to(e, t) {
        return this._valuesEnd = e, void 0 !== t && (this._duration = t), this;
      },
      start: function start(e) {
        this._group.add(this), this._isPlaying = !0, this._onStartCallbackFired = !1, this._startTime = void 0 !== e ? "string" == typeof e ? r.now() + parseFloat(e) : e : r.now(), this._startTime += this._delayTime;
        for (var t in this._valuesEnd) {
          if (this._valuesEnd[t] instanceof Array) {
            if (0 === this._valuesEnd[t].length) continue;
            this._valuesEnd[t] = [this._object[t]].concat(this._valuesEnd[t]);
          }
          void 0 !== this._object[t] && (this._valuesStart[t] = this._object[t], this._valuesStart[t] instanceof Array == !1 && (this._valuesStart[t] *= 1), this._valuesStartRepeat[t] = this._valuesStart[t] || 0);
        }
        return this;
      },
      stop: function stop() {
        return this._isPlaying ? (this._group.remove(this), this._isPlaying = !1, null !== this._onStopCallback && this._onStopCallback(this._object), this.stopChainedTweens(), this) : this;
      },
      end: function end() {
        return this.update(this._startTime + this._duration), this;
      },
      stopChainedTweens: function stopChainedTweens() {
        for (var e = 0, t = this._chainedTweens.length; e < t; e++) this._chainedTweens[e].stop();
      },
      group: function group(e) {
        return this._group = e, this;
      },
      delay: function delay(e) {
        return this._delayTime = e, this;
      },
      repeat: function repeat(e) {
        return this._repeat = e, this;
      },
      repeatDelay: function repeatDelay(e) {
        return this._repeatDelayTime = e, this;
      },
      yoyo: function yoyo(e) {
        return this._yoyo = e, this;
      },
      easing: function easing(e) {
        return this._easingFunction = e, this;
      },
      interpolation: function interpolation(e) {
        return this._interpolationFunction = e, this;
      },
      chain: function chain() {
        return this._chainedTweens = arguments, this;
      },
      onStart: function onStart(e) {
        return this._onStartCallback = e, this;
      },
      onUpdate: function onUpdate(e) {
        return this._onUpdateCallback = e, this;
      },
      onComplete: function onComplete(e) {
        return this._onCompleteCallback = e, this;
      },
      onStop: function onStop(e) {
        return this._onStopCallback = e, this;
      },
      update: function update(e) {
        var t, n, r;
        if (e < this._startTime) return !0;
        !1 === this._onStartCallbackFired && (null !== this._onStartCallback && this._onStartCallback(this._object), this._onStartCallbackFired = !0), n = (e - this._startTime) / this._duration, n = 0 === this._duration || n > 1 ? 1 : n, r = this._easingFunction(n);
        for (t in this._valuesEnd) if (void 0 !== this._valuesStart[t]) {
          var o = this._valuesStart[t] || 0,
            i = this._valuesEnd[t];
          i instanceof Array ? this._object[t] = this._interpolationFunction(i, r) : ("string" == typeof i && (i = "+" === i.charAt(0) || "-" === i.charAt(0) ? o + parseFloat(i) : parseFloat(i)), "number" == typeof i && (this._object[t] = o + (i - o) * r));
        }
        if (null !== this._onUpdateCallback && this._onUpdateCallback(this._object), 1 === n) {
          if (this._repeat > 0) {
            isFinite(this._repeat) && this._repeat--;
            for (t in this._valuesStartRepeat) {
              if ("string" == typeof this._valuesEnd[t] && (this._valuesStartRepeat[t] = this._valuesStartRepeat[t] + parseFloat(this._valuesEnd[t])), this._yoyo) {
                var s = this._valuesStartRepeat[t];
                this._valuesStartRepeat[t] = this._valuesEnd[t], this._valuesEnd[t] = s;
              }
              this._valuesStart[t] = this._valuesStartRepeat[t];
            }
            return this._yoyo && (this._reversed = !this._reversed), void 0 !== this._repeatDelayTime ? this._startTime = e + this._repeatDelayTime : this._startTime = e + this._delayTime, !0;
          }
          null !== this._onCompleteCallback && this._onCompleteCallback(this._object);
          for (var a = 0, c = this._chainedTweens.length; a < c; a++) this._chainedTweens[a].start(this._startTime + this._duration);
          return !1;
        }
        return !0;
      }
    }, r.Easing = {
      Linear: {
        None: function None(e) {
          return e;
        }
      },
      Quadratic: {
        In: function In(e) {
          return e * e;
        },
        Out: function Out(e) {
          return e * (2 - e);
        },
        InOut: function InOut(e) {
          return (e *= 2) < 1 ? .5 * e * e : -.5 * (--e * (e - 2) - 1);
        }
      },
      Cubic: {
        In: function In(e) {
          return e * e * e;
        },
        Out: function Out(e) {
          return --e * e * e + 1;
        },
        InOut: function InOut(e) {
          return (e *= 2) < 1 ? .5 * e * e * e : .5 * ((e -= 2) * e * e + 2);
        }
      },
      Quartic: {
        In: function In(e) {
          return e * e * e * e;
        },
        Out: function Out(e) {
          return 1 - --e * e * e * e;
        },
        InOut: function InOut(e) {
          return (e *= 2) < 1 ? .5 * e * e * e * e : -.5 * ((e -= 2) * e * e * e - 2);
        }
      },
      Quintic: {
        In: function In(e) {
          return e * e * e * e * e;
        },
        Out: function Out(e) {
          return --e * e * e * e * e + 1;
        },
        InOut: function InOut(e) {
          return (e *= 2) < 1 ? .5 * e * e * e * e * e : .5 * ((e -= 2) * e * e * e * e + 2);
        }
      },
      Sinusoidal: {
        In: function In(e) {
          return 1 - Math.cos(e * Math.PI / 2);
        },
        Out: function Out(e) {
          return Math.sin(e * Math.PI / 2);
        },
        InOut: function InOut(e) {
          return .5 * (1 - Math.cos(Math.PI * e));
        }
      },
      Exponential: {
        In: function In(e) {
          return 0 === e ? 0 : Math.pow(1024, e - 1);
        },
        Out: function Out(e) {
          return 1 === e ? 1 : 1 - Math.pow(2, -10 * e);
        },
        InOut: function InOut(e) {
          return 0 === e ? 0 : 1 === e ? 1 : (e *= 2) < 1 ? .5 * Math.pow(1024, e - 1) : .5 * (2 - Math.pow(2, -10 * (e - 1)));
        }
      },
      Circular: {
        In: function In(e) {
          return 1 - Math.sqrt(1 - e * e);
        },
        Out: function Out(e) {
          return Math.sqrt(1 - --e * e);
        },
        InOut: function InOut(e) {
          return (e *= 2) < 1 ? -.5 * (Math.sqrt(1 - e * e) - 1) : .5 * (Math.sqrt(1 - (e -= 2) * e) + 1);
        }
      },
      Elastic: {
        In: function In(e) {
          return 0 === e ? 0 : 1 === e ? 1 : -Math.pow(2, 10 * (e - 1)) * Math.sin(5 * (e - 1.1) * Math.PI);
        },
        Out: function Out(e) {
          return 0 === e ? 0 : 1 === e ? 1 : Math.pow(2, -10 * e) * Math.sin(5 * (e - .1) * Math.PI) + 1;
        },
        InOut: function InOut(e) {
          return 0 === e ? 0 : 1 === e ? 1 : (e *= 2, e < 1 ? -.5 * Math.pow(2, 10 * (e - 1)) * Math.sin(5 * (e - 1.1) * Math.PI) : .5 * Math.pow(2, -10 * (e - 1)) * Math.sin(5 * (e - 1.1) * Math.PI) + 1);
        }
      },
      Back: {
        In: function In(e) {
          var t = 1.70158;
          return e * e * ((t + 1) * e - t);
        },
        Out: function Out(e) {
          var t = 1.70158;
          return --e * e * ((t + 1) * e + t) + 1;
        },
        InOut: function InOut(e) {
          var t = 2.5949095;
          return (e *= 2) < 1 ? e * e * ((t + 1) * e - t) * .5 : .5 * ((e -= 2) * e * ((t + 1) * e + t) + 2);
        }
      },
      Bounce: {
        In: function In(e) {
          return 1 - r.Easing.Bounce.Out(1 - e);
        },
        Out: function Out(e) {
          return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + .75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + .9375 : 7.5625 * (e -= 2.625 / 2.75) * e + .984375;
        },
        InOut: function InOut(e) {
          return e < .5 ? .5 * r.Easing.Bounce.In(2 * e) : .5 * r.Easing.Bounce.Out(2 * e - 1) + .5;
        }
      }
    }, r.Interpolation = {
      Linear: function Linear(e, t) {
        var n = e.length - 1,
          o = n * t,
          i = Math.floor(o),
          s = r.Interpolation.Utils.Linear;
        return t < 0 ? s(e[0], e[1], o) : t > 1 ? s(e[n], e[n - 1], n - o) : s(e[i], e[i + 1 > n ? n : i + 1], o - i);
      },
      Bezier: function Bezier(e, t) {
        for (var n = 0, o = e.length - 1, i = Math.pow, s = r.Interpolation.Utils.Bernstein, a = 0; a <= o; a++) n += i(1 - t, o - a) * i(t, a) * e[a] * s(o, a);
        return n;
      },
      CatmullRom: function CatmullRom(e, t) {
        var n = e.length - 1,
          o = n * t,
          i = Math.floor(o),
          s = r.Interpolation.Utils.CatmullRom;
        return e[0] === e[n] ? (t < 0 && (i = Math.floor(o = n * (1 + t))), s(e[(i - 1 + n) % n], e[i], e[(i + 1) % n], e[(i + 2) % n], o - i)) : t < 0 ? e[0] - (s(e[0], e[0], e[1], e[1], -o) - e[0]) : t > 1 ? e[n] - (s(e[n], e[n], e[n - 1], e[n - 1], o - n) - e[n]) : s(e[i ? i - 1 : 0], e[i], e[n < i + 1 ? n : i + 1], e[n < i + 2 ? n : i + 2], o - i);
      },
      Utils: {
        Linear: function Linear(e, t, n) {
          return (t - e) * n + e;
        },
        Bernstein: function Bernstein(e, t) {
          var n = r.Interpolation.Utils.Factorial;
          return n(e) / n(t) / n(e - t);
        },
        Factorial: function () {
          var e = [1];
          return function (t) {
            var n = 1;
            if (e[t]) return e[t];
            for (var r = t; r > 1; r--) n *= r;
            return e[t] = n, n;
          };
        }(),
        CatmullRom: function CatmullRom(e, t, n, r, o) {
          var i = .5 * (n - e),
            s = .5 * (r - t),
            a = o * o;
          return (2 * t - 2 * n + i + s) * (o * a) + (-3 * t + 3 * n - 2 * i - s) * a + i * o + t;
        }
      }
    }, function (t) {
      e.exports = r;
    }();
  }),
  EASING = {
    "in-out-quad": Tween.Easing.Quadratic.InOut
  },
  scrollTo = function scrollTo(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
      r = scroll(),
      _o = void 0,
      i = new Tween.Tween(r).to({
        x: e,
        y: t
      }, +n.duration || 1e3).easing(EASING[n.ease] || EASING["in-out-quad"]).onUpdate(function () {
        window.scrollTo(r.x, r.y);
      }).onComplete(function () {
        _o = function o() {};
      }).start();
    return (_o = function o() {
      raf_1(_o), Tween.update();
    })(), i;
  },
  scroll = function scroll() {
    return {
      x: window.pageXOffset || document.documentElement.scrollLeft,
      y: window.pageYOffset || document.documentElement.scrollTop
    };
  },
  _this = void 0,
  _arguments = arguments,
  request = function request(e) {
    var t = e.url,
      n = e.method,
      r = void 0 === n ? "GET" : n,
      o = e.body,
      i = void 0 === o ? null : o,
      s = e.headers,
      a = void 0 === s ? {
        "Content-Type": "application/json"
      } : s,
      c = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1e4,
      u = new XMLHttpRequest(),
      l = new Promise(function (e, n) {
        u.open(r, t), u.timeout = c, Object.keys(a).forEach(function (e) {
          u.setRequestHeader(e, a[e]);
        }), u.onload = function () {
          if (u.status >= 200 && u.status < 300) try {
            var t = u.response;
            t && (t = JSON.parse(t)), e(t, u);
          } catch (e) {
            n(u);
          } else n(u);
        }, u.onerror = u.onabort = u.ontimeout = function () {
          return n(u);
        };
        var o = i ? JSON.stringify(i) : null;
        a.hasOwnProperty("Content-Type") && "application/x-www-form-urlencoded" === a["Content-Type"] && (o = (o = Object.keys(i).reduce(function (e, t) {
          return e.push(t + "=" + encodeURIComponent(i[t])), e;
        }, [])).join("&")), u.send(o);
      });
    return l.abort = function () {
      u.abort();
    }, l;
  },
  numberToReal = function numberToReal(e) {
    var t = e.toFixed(2).split(".");
    return t[0] = t[0].split(/(?=(?:...)*$)/).join("."), t.join(",");
  },
  groupBy = function groupBy(e, t) {
    return e.reduce(function (e, n) {
      return (e[n[t]] = e[n[t]] || []).push(n), e;
    }, {});
  },
  interAccountMask = function interAccountMask(e, t) {
    return e = e.replace(/-/gi, ""), e.length > 5 ? e.replace(/(\d{1}$)/, "-$1") : e;
  },
  isVisible = function isVisible(e) {
    var t = e.getBoundingClientRect(),
      n = t.top,
      r = t.bottom,
      o = t.left,
      i = t.right,
      s = window.innerWidth || document.documentElement.clientWidth,
      a = window.innerHeight || document.documentElement.clientHeight;
    return n >= 0 && o >= 0 && i <= s && r <= a;
  },
  invalidsCPF = ["00000000000", "11111111111", "22222222222", "33333333333", "44444444444", "55555555555", "66666666666", "77777777777", "88888888888", "99999999999"],
  checkValidCPF = function checkValidCPF(e) {
    var t = 0,
      n = void 0;
    if (!e) return !1;
    if (!e.match(/([0-9]{2}[.]?[0-9]{3}[.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[.]?[0-9]{3}[.]?[0-9]{3}[-]?[0-9]{2})/)) return !1;
    if (e = e.replace(/\.|-/g, ""), invalidsCPF.indexOf(e) > -1) return !1;
    for (var r = 0; r < 9; r++) t += parseInt(e.charAt(r)) * (10 - r);
    if (10 !== (n = 11 - t % 11) && 11 !== n || (n = 0), n !== parseInt(e.charAt(9))) return !1;
    t = 0;
    for (var o = 0; o < 10; o++) t += parseInt(e.charAt(o)) * (11 - o);
    return 10 !== (n = 11 - t % 11) && 11 !== n || (n = 0), n === parseInt(e.charAt(10));
  },
  checkValidCNPJ = function checkValidCNPJ(e) {
    if (void 0 === e || "" === e) return !1;
    if (14 !== (e = e.replace(/[^\d]+/g, "")).length) return !1;
    if ("00000000000000" === e || "11111111111111" === e || "22222222222222" === e || "33333333333333" === e || "44444444444444" === e || "55555555555555" === e || "66666666666666" === e || "77777777777777" === e || "88888888888888" === e || "99999999999999" === e) return !1;
    for (var t = e.length - 2, n = e.substring(0, t), r = e.substring(t), o = 0, i = t - 7, s = t; s >= 1; s--) o += n.charAt(t - s) * i--, i < 2 && (i = 9);
    var a = o % 11 < 2 ? 0 : 11 - o % 11;
    if ((a = a.toString()) !== r.charAt(0)) return !1;
    t += 1, n = e.substring(0, t), o = 0, i = t - 7;
    for (var c = t; c >= 1; c--) o += n.charAt(t - c) * i--, i < 2 && (i = 9);
    return a = o % 11 < 2 ? 0 : 11 - o % 11, (a = a.toString()) === r.charAt(1);
  },
  WIDTH_LG = 991,
  handleFormPosition = function handleFormPosition() {
    if ("undefined" != typeof document) {
      var e = document.getElementsByClassName("form-section"),
        t = document.querySelector("footer[class*='footer']").offsetHeight,
        n = document.body.scrollHeight,
        r = window.innerWidth;
      e.length > 0 && r > WIDTH_LG ? e[0].style.height = n - t - e[0].offsetTop - 50 + "px" : e.length > 0 && (e[0].style.height = "auto");
    }
  },
  sendGAEvent = function sendGAEvent(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "send",
      r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : function () {};
    window && window.ga && window.ga(n, {
      hitType: "event",
      eventCategory: t,
      eventAction: e,
      hitCallback: r
    });
  },
  spaceBetween = function spaceBetween(e, t) {
    if (!(e && t && document.getElementById(e) && document.getElementById(t))) return 0;
    var n = document.getElementById(e).getBoundingClientRect().bottom;
    return document.getElementById(t).getBoundingClientRect().top - n;
  },
  reacheadElem = function reacheadElem(e, t) {
    t || (t = 700);
    var n = e.getBoundingClientRect().y,
      r = e.getBoundingClientRect().top;
    return n ? n < t : r < t;
  },
  scrollToElement = function scrollToElement(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "in-out-quad",
      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1e3,
      r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
    try {
      r && r.preventDefault();
      var o = ("string" == typeof e ? document.querySelector(e) : e).offsetTop;
      scrollTo(0, o, {
        ease: t,
        duration: n
      });
    } catch (e) {
      console.error(e);
    }
  },
  debounce = function debounce(e, t, n) {
    var r = void 0;
    return function () {
      var o = _this,
        i = _arguments,
        s = function s() {
          r = null, n || e.apply(o, i);
        },
        a = n && !r;
      clearTimeout(r), r = setTimeout(s, t), a && e.apply(o, i);
    };
  },
  throttle = function throttle(e, t) {
    var n = void 0,
      r = void 0;
    return function () {
      var o = this,
        i = arguments;
      r ? (clearTimeout(n), n = setTimeout(function () {
        Date.now() - r >= t && (e.apply(o, i), r = Date.now());
      }, t - (Date.now() - r))) : (e.apply(o, i), r = Date.now());
    };
  },
  actions = Object.freeze({
    request: request,
    numberToReal: numberToReal,
    groupBy: groupBy,
    interAccountMask: interAccountMask,
    isVisible: isVisible,
    checkValidCPF: checkValidCPF,
    checkValidCNPJ: checkValidCNPJ,
    handleFormPosition: handleFormPosition,
    sendGAEvent: sendGAEvent,
    spaceBetween: spaceBetween,
    reacheadElem: reacheadElem,
    scrollToElement: scrollToElement,
    debounce: debounce,
    throttle: throttle
  }),
  _this$1 = void 0,
  EventDispatcher = function EventDispatcher(e) {
    var t = e.action,
      n = e.parameters,
      r = e.children,
      o = "string" == typeof t ? function (e) {
        return actions[t].apply(_this$1, n.split(";").concat(e));
      } : t,
      i = Children.map(r, function (e) {
        if (e.$$typeof) return cloneElement(e);
      });
    return React.createElement("span", {
      className: "event-caller",
      onClick: o
    }, i);
  };
EventDispatcher.defaultProps = {
  children: null,
  action: "",
  parameters: null
};
export { Icon, index as Landing, Modal, Slider, LoadingIndicator, EventDispatcher as EventCaller, actions as Utility };